import Vue from "vue"

export function isTsOuTcf (autorisations) {
  if (!autorisations) {
    return false
  }

  return autorisations.some(
    a =>
      a.statut?.id === Vue.prototype.$catalogues.statutAutorisationDePatique.membre &&
      (a.categorieAutorisation?.id === Vue.prototype.$catalogues.categorieAutorisation.travailleurSocial ||
        a.categorieAutorisation?.id === Vue.prototype.$catalogues.categorieAutorisation.therapieConjugaleFamiliale))
}

export function isTsOuTcfStatutMembreOuAutoriseASInscrire (autorisations) {
  if (!autorisations) {
    return false
  }

  return autorisations.some(
      a =>
          (a.statut?.id === Vue.prototype.$catalogues.statutAutorisationDePatique.membre ||
              a.statut?.id === Vue.prototype.$catalogues.statutAutorisationDePatique.autoriseInscrire) &&
          (a.categorieAutorisation?.id === Vue.prototype.$catalogues.categorieAutorisation.travailleurSocial ||
              a.categorieAutorisation?.id === Vue.prototype.$catalogues.categorieAutorisation.personneAutorisee ||
              a.categorieAutorisation?.id === Vue.prototype.$catalogues.categorieAutorisation.therapieConjugaleFamiliale))
}

export function isDroitsAcquis (autorisations) {
  if (!autorisations) {
    return false
  }

  return autorisations.some(
    a =>
        a.categorieAutorisation?.id === Vue.prototype.$catalogues.categorieAutorisation.registreDroitsAcquis
        && (a.statut?.id === Vue.prototype.$catalogues.statutAutorisationDePatique.membre ||
            a.statut?.id === Vue.prototype.$catalogues.statutAutorisationDePatique.droitsAcquis))
}

export function isCategorieAutorisationPrp (autorisations) {
  if (!autorisations) {
    return false
  }

  return autorisations.some(
    a => a.categorieAutorisation?.id === Vue.prototype.$catalogues.categorieAutorisation.personneAutorisee)
}